import { SystemManagementConfig, SystemManagementQuotaOverrides } from 'pbts/c1/api/settings/v1/system_management'
import { SystemManagementServiceClient } from 'pbts/c1/api/settings/v1/system_management.client'
import { createMutationApi } from './lib/createMutationApi'
import { createUnaryApi } from './lib/createUnaryApi'

export const getSystemManagementConfig = createUnaryApi(
    SystemManagementServiceClient,
    'getSystemManagementConfig',
    (r) => r?.config as SystemManagementConfig,
)

export const updateSystemManagementConfig = createMutationApi(
    SystemManagementServiceClient,
    'updateSystemManagementConfig',
    (r) => r?.config as SystemManagementConfig,
)

export const getSystemManagementQuotaOverrides = createUnaryApi(
    SystemManagementServiceClient,
    'getSystemManagementQuotaOverrides',
    (r) => r?.quotaOverrides as SystemManagementQuotaOverrides,
)
